import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ProgressBar } from "primereact/progressbar";
import { Tag } from "primereact/tag";

const CourseCardDraft = (props) => {
  const { data } = props;
  const [isHovered, setIsHovered] = useState(false);
  const [isStudentHovered, setIsStudentHovered] = useState(false);

  return (
    <div
      className="flex w-full mb-3 border-1 border-300 surface-border"
      style={{ height: '135px' }}
    >
      {/* Image Section - Hidden on mobile (< 768px) */}
      <div className="hidden md:flex flex-shrink-0" style={{ width: '240px', height: '135px' }}>
        <Link to={`/instructor/createCourse/${data.id}`} className="block w-full h-full">
          <img
            src={data.image240x135 || "/assets/images/placeholderImage.jpg"}
            alt={data.title}
            className="w-full h-full"
            style={{ objectFit: 'cover' }}
          />
        </Link>
      </div>

      {/* Content Section */}
      <Link
        to={`/instructor/createCourse/${data.id}`}
        className="flex-grow-1 p-3 relative cursor-pointer hover:surface-100 no-underline text-900"
        style={{ minWidth: 0 }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {/* Hover Overlay */}
        {isHovered && (
          <div
            className="absolute top-0 left-0 w-full h-full flex align-items-center justify-content-center font-bold text-base md:text-xl z-5 px-2 text-center"
            style={{ backgroundColor: 'rgba(255, 255, 255, 0.85)', color: 'var(--highlight-text-color)' }}
          >
            Kursunuzu düzenleyin/yönetin
          </div>
        )}

        {/* Content Flexbox */}
        <div className="flex w-full h-full gap-3" style={{ opacity: isHovered ? 0.1 : 1 }}>
          {/* Title and Status */}
          <div className="flex flex-column justify-content-between" style={{ flex: '1 1 40%', minWidth: 0 }}>
            <div className="font-bold text-sm md:text-base line-height-3 overflow-hidden text-overflow-ellipsis"
                 style={{ display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>
              {data.title}
            </div>
            <div className="flex align-items-center gap-2">
              {data.isPublished ?
                <Tag severity="success" value="Yayınlandı"/> :
                <Tag severity="info" value="Taslak"/>
              }
            </div>
          </div>

          {/* Progress Section */}
          <div className="hidden lg:flex flex-column justify-content-center gap-2" style={{ flex: '1 1 40%', minWidth: 0 }}>
            <div className="font-bold text-sm overflow-hidden text-overflow-ellipsis white-space-nowrap">
              {data.isPublished ? "Kursunuzu düzenleyin" : "Kursunuzu tamamlayın"}
            </div>
            <ProgressBar value={data.isPublished ? 100 : 50} style={{ height: '8px' }} />
          </div>
        </div>
      </Link>

      {/* Student Count - Separate clickable area */}
      <div
        className="flex-shrink-0 relative border-left-1 surface-border"
        style={{ width: '110px' }}
        onMouseEnter={() => setIsStudentHovered(true)}
        onMouseLeave={() => setIsStudentHovered(false)}
      >
        <Link
          to={`/instructor/courses/${data.id}/students`}
          className="flex flex-column align-items-center justify-content-center cursor-pointer hover:surface-100 no-underline w-full h-full p-2"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Student Hover Overlay */}
          {isStudentHovered && (
            <div
              className="absolute top-0 left-0 w-full h-full flex align-items-center justify-content-center font-bold text-sm z-5 px-1 text-center"
              style={{ backgroundColor: 'rgba(255, 255, 255, 0.85)', color: 'var(--highlight-text-color)' }}
            >
              Öğrencilere göz atın
            </div>
          )}

          <div style={{ opacity: isStudentHovered ? 0.1 : 1 }} className="flex flex-column align-items-center justify-content-center gap-1">
            <div className="font-bold" style={{ fontSize: '2rem', lineHeight: 1, color: 'var(--highlight-text-color)' }}>
              {data.numSubscribers || 0}
            </div>
            <div className="text-600 text-xs white-space-nowrap">Öğrenci</div>
          </div>
        </Link>
      </div>
    </div>
  );
};

export default CourseCardDraft;
